<div class="migration-banner" *ngIf="showMigrationBanner">
  <span class="migration-banner__icon">⚠️</span>
  <span class="migration-banner__text">
    <strong>Estamos migrando nossos usuários para um novo diretório.</strong>
    Se você está tendo problemas para entrar,
    <a [href]="migrationSwitchUrl" class="migration-banner__link">
      {{ isLegacyMode ? 'clique aqui para usar o acesso padrão' : 'clique aqui para usar o acesso legado' }}
    </a>.
  </span>
</div>
<section class="login">
    <div class="card-login">
        <form action="" fxLayout="column" fxLayoutAlign="center center">
            <span class="container-logo-login">
                    <img src="{{logoUrl}}" style="width: 236px;">
            </span>
            <div>
                <span fxFlex="100%" fxLayoutAlign="center" style="padding-bottom: 36px; text-align: center;">Aguarde enquanto realizamos o processo de Login</span>
            </div>
            <div class="spinner">
                <div>
                    <mat-spinner></mat-spinner>
                </div>
            </div>
        </form>
    </div>
</section>
